import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Body2 } from 'ui/theme';
import { Modal, ModalBody, ModalHeader, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { DESELECT_CHANNELS_MODAL } from '../../../constants';
import { closeModal } from '../../../ducks';

export const DESELECT_CHANNEL_BUTTON_CONFIRM_TEST_ID = 'deselect-channels-button-confirm';

const StyledModalBody = styled(ModalBody)``;
export interface DeselectChannelsModalProps {
  /** Whether modal is open and visible */
  isOpen: boolean;
  /** Callback function on closing modal */
  onCancel: () => void;
  /** Callback function on confirm action */
  onConfirm: () => void;
}

export const DeselectChannelsModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: DeselectChannelsModalProps) => {
  const dispatch = useDispatch();
  const closeDeselectChannelsModal = () => {
    onCancel();
    dispatch(closeModal(DESELECT_CHANNELS_MODAL));
  };
  const onDeselectChannels = () => {
    onConfirm();
    dispatch(closeModal(DESELECT_CHANNELS_MODAL));
  };
  return (
    <Modal
      id={DESELECT_CHANNELS_MODAL}
      isModalOpen={isOpen}
      onClose={closeDeselectChannelsModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Disable channel(s)?</ModalHeader>
      <StyledModalBody>
        <Body2>Are you sure you want to continue? Any existing campaign setup will be lost.</Body2>
      </StyledModalBody>
      <ModalFooter cancelLabel="Cancel">
        <Button
          data-test={DESELECT_CHANNEL_BUTTON_CONFIRM_TEST_ID}
          onClick={onDeselectChannels}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
        >
          Disable
        </Button>
      </ModalFooter>
    </Modal>
  );
};
